import styled from 'styled-components';

/** Le container global pour tout ce qui est affichage des résultats  */
export const Container = styled.div`
  display: flex;
  padding: 16px 0;
  flex-direction: column;
  gap: 24px;
`;

/** Tout en bas des résultats, une hauteur fixe pour indiquer/détecter les chargements */
export const BottomSpace = styled.div`
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
